import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StockTakesListQueryVariables = Types.Exact<{
  input: Types.StockTakesInput;
  options?: Types.InputMaybe<Types.StockTakesOptions>;
}>;


export type StockTakesListQuery = { readonly __typename?: 'Query', readonly stockTakes: { readonly __typename?: 'StockTakesPage', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'StockTake', readonly id: string, readonly locationId: string, readonly finalisedAt?: string | null, readonly finalisedBy?: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number, readonly totalNewLotsAdded: number, readonly totalQuantityAdded: number, readonly totalQuantityRemoved: number } }> } };


export const StockTakesListDocument = gql`
    query stockTakesList($input: StockTakesInput!, $options: StockTakesOptions) {
  stockTakes(input: $input, options: $options) {
    items {
      id
      locationId
      finalisedAt
      finalisedBy {
        person {
          firstname
          lastname
        }
      }
      aggregateInfo {
        totalLotCount
        reviewedLotCount
        totalNewLotsAdded
        totalQuantityAdded
        totalQuantityRemoved
      }
    }
    totalCount
  }
}
    `;

/**
 * __useStockTakesListQuery__
 *
 * To run a query within a React component, call `useStockTakesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockTakesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockTakesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useStockTakesListQuery(baseOptions: Apollo.QueryHookOptions<StockTakesListQuery, StockTakesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockTakesListQuery, StockTakesListQueryVariables>(StockTakesListDocument, options);
      }
export function useStockTakesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockTakesListQuery, StockTakesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockTakesListQuery, StockTakesListQueryVariables>(StockTakesListDocument, options);
        }
export type StockTakesListQueryHookResult = ReturnType<typeof useStockTakesListQuery>;
export type StockTakesListLazyQueryHookResult = ReturnType<typeof useStockTakesListLazyQuery>;
export type StockTakesListQueryResult = Apollo.QueryResult<StockTakesListQuery, StockTakesListQueryVariables>;